import { buildLabel as label } from '@tv-casino/viewmodels/lib/playMoney.js';

/**
 * Which build is on the screen, stamped in by `vite.config.ts` at build time.
 * Tests and a bare `vitest` run have no stamp, so everything falls back to a
 * plain "dev" rather than crashing on an undefined global. The label's shape
 * lives in `@tv-casino/viewmodels/lib/playMoney` so the phone app matches it.
 */
export { RELEASE_STAGE } from '@tv-casino/viewmodels/lib/playMoney.js';

const env = import.meta.env as Record<string, string | undefined>;

export const APP_VERSION: string = env.VITE_APP_VERSION || 'dev';
export const APP_COMMIT: string = env.VITE_APP_COMMIT || '';

/** "v0.1.0-alpha · a29b142", or "dev-alpha" when nothing was stamped. */
export function buildLabel(version = APP_VERSION, commit = APP_COMMIT): string {
  return label(version, commit);
}
